<template>
    <div class="banner-container">
        <article
            ref="banner"
            class="banner"
            :class="[showArrow]"
        >
            <div class="banner__inner">
                <ul class="banner__list">
                    <li
                        v-for="(item, index) in content.items"
                        :key="index"
                        class="banner__item"
                    >
                        <zoe-atom-media
                            v-if="mediaIsNotEmpty(item.media?.value) || mediaIsNotEmpty(item.image?.value)"
                            ref="media"
                            class="banner__media"
                            :item="item.media?.value || item.image?.value"
                            @load="onMediaLoaded"
                        />

                        <zoe-atom-text
                            v-if="stringIsNotEmpty(item.text.value)"
                            class="banner__text"
                            :item="item.text.value"
                        />
                    </li>
                </ul>
            </div>
        </article>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { componentProps } from '../../../../../mixins/component/component';
import ZoeAtomMedia from '../../../../atoms/media/v1.0.0/zoe-atom-media.vue';
import ZoeAtomText from '../../../../atoms/text/v1.0.0/zoe-atom-text.vue';
import { mediaIsNotEmpty } from '../../../../../../../resources/frontend/js/mixins/get-page-data';
import { stringIsNotEmpty } from '../../../../../../../resources/frontend/js/mixins/get-page-data';

const store = useStore();
const props = defineProps({
    content: componentProps.content,
});

const banner = ref(null);
const media = ref(null);

onMounted(() => {
    if (!media.value) {
        store.commit('component/setOrganismValue', {
            component: 'banner',
            object: { height: Math.round(banner.value.getBoundingClientRect().height) },
        });
    }
});

const onMediaLoaded = () => {
    if (banner.value) {
        store.commit('component/setOrganismValue', {
            component: 'banner',
            object: { height: Math.round(banner.value.getBoundingClientRect().height) },
        });
    }
};

const showArrow = computed(() => {
    return props.content.showArrow.value ? 'banner--arrow' : '';
});
</script>

<style lang="scss" scoped>
@use 'zoe-organism-banner';

@layer organism {
    .banner {
        --background: v-bind('content.style["background"].value');
    }
}
</style>
